import { AUDIT_URL } from 'config/api';
import { fetchWithTimeout } from 'global-utils/api';
import { getProjectInfo } from 'global-utils/get-attributes';
import { globalScope } from 'global-utils/globals';
import {
  isCookiesAllowed,
  userGaveConsent,
  userConfirmedAge,
  isLocalStorageAvailable
} from 'global-utils/cookie-utils';

const isLocalStorageOpen = isLocalStorageAvailable();

async function sendAuditInfo({
  type,
  market
}: {
  type?: string;
  market?: string;
}) {
  const { userLocation: country } = globalScope;
  let result;
  const queryParams = `?${type ? `userConsent=${type}&` : ''}${
    market ? `market=${market}&` : ''
  }${country ? `country=${country}` : ''}`;
  const URL = `${AUDIT_URL}/cookie-consent${queryParams}`;
  try {
    result = await fetchWithTimeout(URL, 5000, {
      'X-Forwarded-PathParams': window.location.pathname
    });
  } catch (err) {
    console.error(err);
  }
  return result;
}

async function sendAgeGateAudit({
  rememberMe,
  olderThan
}: {
  rememberMe?: boolean;
  olderThan?: boolean;
}) {
  let result;
  const queryParams = `?${
    typeof rememberMe !== 'undefined' ? `rememberMe=${rememberMe}&` : ''
  }${typeof olderThan !== 'undefined' ? `olderThan=${olderThan}` : ''}`;
  const URL = `${AUDIT_URL}/age-gateway${queryParams}`;

  try {
    result = await fetchWithTimeout(URL, 5000, {
      'X-Forwarded-PathParams': window.location.pathname
    });
  } catch (err) {
    console.error(err);
  }

  return result;
}

async function sendErrorLog({
  origin,
  errorCode
}: {
  origin: string;
  errorCode?: string;
}) {
  const { userLocation: country } = globalScope;
  const hasCookieConsent =
    typeof userGaveConsent() !== 'undefined' ? !userGaveConsent() : undefined;
  const hasAgeGateway =
    typeof userConfirmedAge() !== 'undefined' ? !userConfirmedAge() : undefined;
  const { prjMarket: market } = getProjectInfo();
  const cookiesAllowed = isCookiesAllowed();
  let result;
  const loggerEid = isLocalStorageOpen
    ? sessionStorage.getItem('cbgccpSessionId') || undefined
    : undefined;
  const queryParams = `?${
    typeof market !== 'undefined' ? `market=${market}&` : ''
  }${typeof country !== 'undefined' ? `country=${country}&` : ''}${
    typeof cookiesAllowed !== 'undefined'
      ? `cookiesAllowed=${cookiesAllowed}&`
      : ''
  }${typeof errorCode !== 'undefined' ? `errorCode=${errorCode}&` : ''}${
    typeof loggerEid !== 'undefined' ? `loggerEid=${loggerEid}&` : ''
  }${
    typeof hasCookieConsent !== 'undefined'
      ? `hasCookieConsent=${hasCookieConsent}&`
      : ''
  }${
    typeof hasAgeGateway !== 'undefined'
      ? `hasAgeGateway=${hasAgeGateway}&`
      : ''
  }${typeof origin !== 'undefined' ? `origin=${origin}` : ''}`;

  const URL = `${AUDIT_URL}/plugin/logger${queryParams}`;

  try {
    result = await fetch(URL, {
      headers: { 'X-Forwarded-PathParams': window.location.pathname }
    });

    const sessionId = isLocalStorageOpen
      ? sessionStorage.getItem('cbgccpSessionId')
      : undefined;
    // if session id is not set, set it
    if (!sessionId || typeof sessionId === 'undefined') {
      const response = await result.json();
      if (isLocalStorageOpen) {
        sessionStorage.setItem('cbgccpSessionId', response?.loggerEid);
      }
    }
  } catch (err) {
    console.error(err);
  }

  return result;
}

export { sendAuditInfo, sendAgeGateAudit, sendErrorLog };
